module.exports = __webpack_public_path__ + "img/footerlogo.e9cbdcfb.svg";